module.exports = __webpack_public_path__ + "e93bb772b1479e8d54695f191f9f18c3.gltf";